/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import UploadDoc from "./uploadDoc";
import Sidebar from "../sidebar/Sidebar";
import Loader from "../../components/loader";
import Skeleton from "react-loading-skeleton";
import Paginator from "../../shared/paginator";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header/Header";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteLegalDoc,
  getDocumentDetails,
} from "../../redux/slice/legalDoc/legalAPI";
import { getFormattedDate, paginateData } from "../../helper/util";
import "./styles.scss";

export default function LegalDocuments() {
  const [isEdit, setIsEdit] = useState(false);
  const [listLength, setListLength] = useState(0);
  const [editDocData, setEditDocData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [showLoader, setShowLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [documentList, setDocumentList] = useState(true);
  const [documentForm, setDocumentForm] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(true);
  const { legalDocList } = useSelector((state) => state.legalDoc);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentRows = 10;

  const withPagination = () => {
    setListLength(legalDocList.length);
    const newList = [...legalDocList];
    newList.sort((a, b) => b.modifiedAt - a.modifiedAt);
    setFilteredData(paginateData(currentRows, newList, currentPage));
  };

  useEffect(() => {
    withPagination();
  }, [currentPage, legalDocList]);

  useEffect(() => {
    setShowSkeleton(true);
    setTimeout(() => {
      setShowSkeleton(false);
    }, 2000);
  }, [filteredData]);

  const onPaginateData = useCallback((row, page) => {
    setCurrentPage(page);
  }, []);

  const goToDocumentList = () => {
    setDocumentForm(false);
    setDocumentList(true);
  };
  const removeDoc = (doc) => {
    const params = {
      orgId: doc?.orgId,
      docId: doc?.docId,
    };
    Swal.fire({
      text: "Are you sure you want to delete this Document?",
      showCancelButton: true,
      confirmButtonColor: "#fbbc05",
      cancelButtonColor: "#cccccc",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setShowLoader(true);
        dispatch(deleteLegalDoc(params))
          .then((response) => {
            // setShowSkeleton(true);
            if (response?.data.success) {
              setShowLoader(false);
              Swal.fire({
                title: response.data.message,
                icon: "success",
              });
            } else {
              setShowLoader(false);
              Swal.fire({
                title: response.data.message,
                icon: "error",
              });
            }
          })
          .catch((error) => {
            setShowLoader(false);
            Swal.fire({
              title: error,
              icon: "error",
            });
          });
      }
    });
  };

  const editDoc = (orgId, docId) => {
    setShowLoader(true);
    const params = {
      orgId: orgId,
      documentId: docId,
    };
    dispatch(getDocumentDetails(params))
      .then((response) => {
        setShowLoader(false);
        if (response?.data?.success) {
          setEditDocData(response?.data?.data);
          setIsEdit(true);
          setDocumentForm(true);
          setDocumentList(false);
        } else {
          Swal.fire({
            title: response?.data?.message
              ? response?.data?.message
              : "Something went wrong",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setShowLoader(false);
        Swal.fire({
          title: error?.message,
          icon: "error",
        });
      });
  };

  const backToMainPage = () => {
    // When we click on back button
    if (documentForm && !documentList) {
      setDocumentForm(false);
      setDocumentList(true);
    } else {
      navigate("/");
    }
  };

  return (
    <div className='container'>
      <Header backToMainPage={backToMainPage} />
      <div className='d-flex'>
        <Sidebar />
        <div className='messagetemplates border-end'>
          {documentList && (
            <div className='messagetable'>
              <div className='row justify-content-between align-items-center'>
                <div className='col-lg-6'>
                  <h2>Legal Documents</h2>
                </div>
                <div className='col-lg-6 text-end'>
                  <button
                    onClick={() => {
                      setIsEdit(false);
                      setEditDocData();
                      setDocumentForm(true);
                      setDocumentList(false);
                    }}
                  >
                    Create Document
                  </button>
                </div>
              </div>
              <div className='table-message'>
                <table className='table table-hover'>
                  <thead>
                    <tr>
                      <th>Document Name</th>
                      <th>Category</th>
                      <th>Country</th>
                      <th>Language</th>
                      <th>Type</th>
                      <th>Created Date</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {showSkeleton ? (
                      <tr>
                        <td colSpan='8'>
                          <Skeleton count={10} height={30} duration={2} />
                        </td>
                      </tr>
                    ) : filteredData && filteredData.length > 0 ? (
                      filteredData.map((doc, i) => {
                        return (
                          <tr key={i}>
                            <td>{doc?.name}</td>
                            <td>{doc?.type}</td>
                            <td>{doc?.country}</td>
                            <td>{doc?.language}</td>
                            <td>{doc?.fileType}</td>
                            <td>
                              {getFormattedDate(
                                doc?.modifiedAt
                                  ? doc.modifiedAt
                                  : doc?.createdAt
                              )}
                            </td>
                            <td className='width-70 text-center  hoverIt'>
                              <img
                                src='/img/pencil-square.svg'
                                alt=''
                                onClick={() => editDoc(doc.orgId, doc.docId)}
                              />
                            </td>
                            <td className='width-70 text-center hoverIt'>
                              <img
                                src='/img/trash3.svg'
                                alt=''
                                onClick={() => removeDoc(doc)}
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan='8'className="text-center" style={{border:'0px'}}>
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <Paginator
                defaultRows={currentRows}
                totalRecords={listLength}
                onPaginateData={onPaginateData}
              />
            </div>
          )}
          {documentForm && (
            <div className='messageform'>
              <UploadDoc
                isEdit={isEdit}
                data={editDocData}
                setShowLoader={setShowLoader}
                goToDocumentList={goToDocumentList}
              />
            </div>
          )}
        </div>
      </div>
      <Loader showLoader={showLoader} />
    </div>
  );
}
